<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">
              Nomor
              <i
                :class="
                  currentSort === 'nomor'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('desc')">
              Deskripsi
              <i
                :class="
                  currentSort === 'desc'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/SIUPAL.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        desc: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          nomor: 1,
          desc: 'Angkutan Laut Dalam Negeri Untuk Barang Khusus',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          nomor: 2,
          desc: 'Angkutan Laut Dalam Negeri Untuk Barang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          nomor: 3,
          desc: 'Angkutan Laut Dalam Negeri Tramper Untuk Barang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          nomor: 4,
          desc: 'Angkutan Laut Dalam Negeri Linier Untuk Penumpang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          nomor: 5,
          desc: 'Angkutan Laut Dalam Negeri Tramper Untuk Penumpang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          nomor: 6,
          desc: 'Angkutan Laut Luar Negeri Tramper Untuk Barang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          nomor: 7,
          desc: 'Angkutan Laut Luar Negeri Tramper Untuk Penumpang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          nomor: 8,
          desc: 'Angkutan Laut Luar Negeri Untuk Barang Khusus',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        kode: data.kode,
        desc: data.desc,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    siupalData() {
      const result = this.$store.state.mdDatabaseStore.siupalData
      return result
    },
    sortedData() {
      return this.siupalData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
